"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const web_ui_1 = require("@gibme/web-ui");
const api_1 = __importDefault(require("../api"));
const types_1 = require("../../types");
const common_1 = require("../common");
(0, web_ui_1.$)(document).ready(() => {
    const card = (0, web_ui_1.$)('#client-portal-card');
    const table = (0, web_ui_1.createDataTable)('#client_file_list')
        .draw()
        .columns.adjust()
        .responsive.recalc();
    const upload_table = (0, web_ui_1.createDataTable)((0, web_ui_1.$)('#client_uploaded_file_list'))
        .draw()
        .columns.adjust()
        .responsive.recalc();
    card.on('refresh', () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            web_ui_1.LoadingOverlay.show();
            {
                const records = yield api_1.default.listFiles();
                table.clear();
                for (const record of records) {
                    table.row.add([
                        record.year,
                        record.type,
                        record
                    ]).draw();
                    (0, web_ui_1.$)(`#download_${record.client_id}${record.type}${record.year}`).on('click', () => {
                        api_1.default.downloadFile(record);
                    });
                }
            }
            {
                const records = yield api_1.default.listClientUploads();
                upload_table.clear();
                for (const record of records) {
                    upload_table.row.add([
                        record.display_name,
                        record.timestamp,
                        record
                    ]).draw();
                    (0, web_ui_1.$)(`#client_upload_${record.id}`).on('click', () => {
                        api_1.default.downloadClientFile(record);
                    });
                }
            }
        }
        finally {
            table.draw()
                .columns.adjust()
                .responsive.recalc();
            upload_table.draw()
                .columns.adjust()
                .responsive.recalc();
            web_ui_1.LoadingOverlay.hide();
        }
    }));
    (0, web_ui_1.$)('#client_portal_file_button').on('click', () => __awaiter(void 0, void 0, void 0, function* () {
        const file_input = (0, web_ui_1.$)('#client_portal_file_input');
        try {
            web_ui_1.LoadingOverlay.show();
            const [contents, name] = yield (0, common_1.readFileInputField)(file_input);
            const payload = { contents, name };
            const status = yield api_1.default.uploadClientFile(payload);
            if (status === types_1.HTTPError.CREATED) {
                file_input.val('');
                return card.trigger('refresh');
            }
            web_ui_1.LoadingOverlay.hide();
            return web_ui_1.StatusModal.show({
                title: 'An Error Occurred!',
                body: 'An error occurred! Please try again!'
            });
        }
        catch (error) {
            web_ui_1.LoadingOverlay.hide();
            return web_ui_1.StatusModal.show({
                title: 'An Error Occurred!',
                body: 'An error occurred! Please try again!'
            });
        }
    }));
});
